<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:items-start lg:gap-7">
    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Basic settings</h3>
        <bly-native-text-field
          :value="model.name"
          label="Name"
          :error="errors.name"
          required
          @input="updateRoot('name', $event)"
        />
        <bly-native-textarea-field
          :value="model.description"
          label="Description"
          @input="updateRoot('description', $event)"
        />
        <bly-native-text-field
          v-if="mode === 'create'"
          :value="model.id"
          label="ID"
          placeholder="Optional custom ID"
          @input="updateRoot('id', $event)"
        />
      </div>
    </section>

    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Location configuration</h3>
        <bly-native-text-field
          :value="model.location.code"
          label="Code"
          :error="errors['location.code']"
          required
          @input="updateLocation('code', $event)"
        />
        <bly-native-select-field
          :value="model.location.type"
          label="Type"
          :error="errors['location.type']"
          :options="typeOptions"
          required
          @input="updateLocation('type', $event)"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "LocationPermissionForm",
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "create",
    },
    locationTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model() {
      return this.value;
    },
    typeOptions() {
      return (this.locationTypes || []).map((type) => ({
        value: type,
        label: type,
      }));
    },
  },
  methods: {
    updateRoot(field, value) {
      this.$emit("input", {
        ...this.model,
        [field]: value,
      });
    },
    updateLocation(field, value) {
      this.$emit("input", {
        ...this.model,
        location: {
          ...(this.model.location || {}),
          [field]: value,
        },
      });
    },
  },
};
</script>
